import { PRODUCT_ID_LIST, PRODUCT_NAME_LIST, PRODUCT_TYPES } from "./sharedConstants";

export const getProductName = (pId: number) => {
    let productName: string;
    switch(pId) {
        case PRODUCT_ID_LIST.SPRINT_BUSINESS_ENGLISH : 
        productName = PRODUCT_NAME_LIST.SPRINT_BUSINESS_ENGLISH
        break;
        case PRODUCT_ID_LIST.SPRINT_BUSINESS_GERMAN : 
        productName = PRODUCT_NAME_LIST.SPRINT_BUSINESS_GERMAN
        break;
        case PRODUCT_ID_LIST.SPRINT_BUSINESS_FRENCH : 
        productName = PRODUCT_NAME_LIST.SPRINT_BUSINESS_FRENCH
        break;
        case PRODUCT_ID_LIST.SPRINT_BUSINESS_SPANISH : 
        productName = PRODUCT_NAME_LIST.SPRINT_BUSINESS_SPANISH
        break;
        case PRODUCT_ID_LIST.SOLO_BUSINESS_ENGLISH : 
        productName = PRODUCT_NAME_LIST.SOLO_BUSINESS_ENGLISH
        break;
        case PRODUCT_ID_LIST.SOLO_BUSINESS_GERMAN : 
        productName = PRODUCT_NAME_LIST.SOLO_BUSINESS_GERMAN
        break;
        case PRODUCT_ID_LIST.SOLO_BUSINESS_FRENCH : 
        productName = PRODUCT_NAME_LIST.SOLO_BUSINESS_FRENCH
        break;
        case PRODUCT_ID_LIST.SOLO_BUSINESS_SPANISH : 
        productName = PRODUCT_NAME_LIST.SOLO_BUSINESS_SPANISH
        break;
        default : productName= ""
        break;
    }
    return productName;
}

export const getProductType = (license: any) => {
    let productType: string;
    let licenseId: number;
    if(license.productId) {
        licenseId = Number(license.productId);
    } else {
        licenseId = Number(license);
    }
    switch(licenseId) {
        case PRODUCT_ID_LIST.SPRINT_BUSINESS_ENGLISH : 
        case PRODUCT_ID_LIST.SPRINT_BUSINESS_GERMAN : 
        case PRODUCT_ID_LIST.SPRINT_BUSINESS_FRENCH : 
        case PRODUCT_ID_LIST.SPRINT_BUSINESS_SPANISH : 
                productType = PRODUCT_TYPES.SPRINT
        break;
        case PRODUCT_ID_LIST.SOLO_BUSINESS_ENGLISH :
        case PRODUCT_ID_LIST.SOLO_BUSINESS_GERMAN :
        case PRODUCT_ID_LIST.SOLO_BUSINESS_FRENCH :
        case PRODUCT_ID_LIST.SOLO_BUSINESS_SPANISH : 
                productType = PRODUCT_TYPES.SOLO
        break;
        case PRODUCT_ID_LIST.SPRINT_BUSINESS_SKILLS : 
                productType = PRODUCT_TYPES.SPRINT_SKILL
        break;
        default : productType= ""
        break;
    }
    return productType;
}

// === Client side ===
const crypto = window.crypto;
export const getRandomNumber = (index : number) => {
    const array = new Uint32Array(index + 1);
    return crypto?.getRandomValues(array)[0]; // Compliant for security-sensitive use cases
}

